<template>
  <div>
    <v-card class="pa-5">
      <v-card-title>
        <v-spacer/>
        <v-text-field
          style="max-width: 250px"
          dense
          outlined
          hide-details
          clearable
          :placeholder="$t('general.search')"
          v-model="search"
          append-icon="search"
          class="mr-2"
          @click:append="searching"
          @keyup.enter="searching"
        />
        <!--v-btn
          class="mr-2"
          color="primary"
          outlined
          to="/checklists/default_questionnaires"
        >
          {{$t('general.defaultTests')}}
        </v-btn-->
        <v-btn
          color="primary"
          to="/checklists/default_questionnaires">
          {{$t('tests.add')}}
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="tests"
          :search="search"
          :loading="loadingTable"
          :loading-text="$t('general.loading')"
          :server-items-length="options.totalItems"
          :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
          :options.sync="options"
          @update:page="get"
          @update:items-per-page="get"
          @update:sort-by="get"
          @update:sort-desc="get"
        >
        <template v-slot:item.sites="{ item }">
          <template v-for="site in item.sites">
            <v-chip
              :key="site.id"
              class="mx-1"
              small
            >
              {{site.name}}
            </v-chip>
          </template>
        </template>
        <template v-slot:item.unit_types="{ item }">
          <template v-for="unit_type in item.unit_types">
            <v-chip
              :key="unit_type.id"
              class="mx-1"
              small
            >
              {{unit_type.name}}
            </v-chip>
          </template>
        </template>
        <template v-slot:item.country="{ item }">
          {{item.country.name}}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="editItem(item)"
              >
                far fa-edit
              </v-icon>
            </template>
            <span>{{$t('general.edit')}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                class="mr-2"
                v-on="on"
                @click="deleteItem(item)"
              >
                far fa-trash-alt
              </v-icon>
            </template>
            <span>{{$t('general.remove')}}</span>
          </v-tooltip>
        </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="deleteDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="error--text grey lighten-5"
        >
          {{$t('tests.delete')}}
        </v-card-title>

        <v-card-text class="pt-5">
          <span>{{$t('tests.delMessage')}}</span> <span class="font-weight-bold">{{item.name}}</span> ?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            outlined
            @click="deleteDialog = false"
          >
           {{$t('general.cancel')}}
          </v-btn>
          <v-btn
            color="error"
            @click="deleteTest"
          >
           {{$t('general.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    
  </div>
</template>

<script>
export default {
  data () {
    return {
      search: '',
      deleteDialog: false,
      loadingTable: true,
      item: {
        id: 0,
        country: '',
        name: ''
      },
      tests: [],
      options: {
        page: 1,
        itemsPerPage: 15,
        totalItems: 0
      }
    }
  },
  created () {
    this.get()
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'name'
        },
        {
          text: this.$t('general.sites'),
          align: 'center',
          value: 'sites',
          sortable: true
        },
        {
          text: this.$t('general.unitTypes'),
          align: 'center',
          value: 'unit_types',
          sortable: true
        },
        {
          text: this.$t('address.country'),
          align: 'center',
          value: 'country'
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false
        }
      ]
    }
  },
  watch: {
    search (val) {
      if (val === '' || val === null) {
        this.options.page = 1
        this.options.perPage = 5
        this.get()
      }
    }
  },
  methods: {
    get () {
      this.loadingTable = true
      this.$store.dispatch('tests/get',{
        event: {
          context: this,
          item: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            sortKey: this.options.sortBy ? this.options.sortBy[0] : 'id',
            ord: this.options.sortDesc && this.options.sortDesc[0] ? 'asc' : 'desc',
            find: this.search
          }
        }
      })
    },
    searching () {
      this.options.page = 1,
      this.options.perPage = -1,
      this.get()
    },
    editItem (item) {
      this.$router.push('/checklists/edit/' + item.id)
    },
    deleteItem (item) {
      this.item = item
      this.deleteDialog = true
    },
    deleteTest () {
      this.$store.dispatch('tests/delete',{
        event: {
          context: this,
          id: this.item.id
        }
      })
      this.deleteDialog = false
    }
  }
}
</script>